import { ActionSurface } from '@/components/patterns/action-surface'
import { Typography } from '@/components/ui/typography'
import type { Category } from '@/lib/services/categories/categories.types'
import { cn } from '@/lib/utils'
import { getCategoryTileColorOption } from './category-tile-colors'

type ShortcutTileCategory = Pick<Category, 'id' | 'name' | 'pos_color'>

/**
 * A quick-add shortcut in catalog search results: its tile's color and shape, a little smaller,
 * without the tile's drag and color buttons.
 */
export function ShortcutResultTile<TCategory extends ShortcutTileCategory>({
  category,
  disabled = false,
  onAdd,
}: {
  category: TCategory
  disabled?: boolean
  onAdd: (category: TCategory) => void
}) {
  return (
    <ActionSurface
      appearance="bare"
      padding="compact"
      radius="control"
      disabled={disabled}
      onClick={() => onAdd(category)}
      className={cn(
        'min-h-20 w-44 shrink-0 flex-col justify-end',
        getCategoryTileColorOption(category).className
      )}
    >
      <Typography variant="h5" className="line-clamp-2">
        {category.name}
      </Typography>
    </ActionSurface>
  )
}
